import React from "react";
import {makeStyles, Table, TableBody, TableCell, TableHead, TableRow} from "@material-ui/core";
import Tr from "translations/Translations";
import PropTypes from "prop-types";
import OfferChoiceRow from "./OfferChoiceRow";

const useStyles = makeStyles(theme => ({
    table: {
        border: `solid 3px ${theme.palette.background.paper}`,
        "& .MuiTableCell-root": {
            border: `solid 1px ${theme.palette.border.dark}`,
            padding: theme.spacing()
        }
    },
    headRow: {
        "&>.MuiTableCell-head": {
            textAlign: "center",
            borderBottom: `solid 3px ${theme.palette.primary.main}`
        }
    },
    partColumn: {
        width: 200
    },
    contractorColumn: {
        width: 250
    },
    valueColumn: {
        width: 150
    },
    scoreColumn: {
        width: 100
    },
    checkColumn: {
        width: 20
    }

}));

function OfferChoiceTable(
    {
        demandId,
        editable,
        working,
        offerChoiceList,
        updateStatus,
        modifyChoice,
    }) {

    const classes = useStyles();

    return (<Table className={classes.table}>
        <TableHead>
            <TableRow className={classes.headRow}>
                <TableCell className={classes.partColumn}>{Tr("part")}</TableCell>
                <TableCell className={classes.contractorColumn}>{Tr("contractor")}</TableCell>
                <TableCell className={classes.valueColumn}>{Tr("offer_value")}</TableCell>
                <TableCell className={classes.scoreColumn}>{Tr("score")}</TableCell>
                <TableCell className={classes.checkColumn}></TableCell>
                <TableCell className={classes.statusColumn}></TableCell>
            </TableRow>
        </TableHead>
        <TableBody>
            {
                offerChoiceList.items.map((element, index) => {
                    const key = "" + element.identity + element.canceled + element.editable;
                    return <OfferChoiceRow
                        key={key}
                        demandId={demandId}
                        updateStatus={updateStatus}
                        modifyChoice={modifyChoice}
                        offerChoiceRow={element}
                        rowNumber={index}
                        working={working}
                        editable={editable}
                    />
                })
            }
        </TableBody>
    </Table>)
}

OfferChoiceTable.propTypes = {
    demandId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    editable: PropTypes.bool.isRequired,
    working: PropTypes.bool.isRequired,
    offerChoiceList: PropTypes.object.isRequired,
    updateStatus: PropTypes.func.isRequired,
    modifyChoice: PropTypes.func.isRequired,
}

export default OfferChoiceTable;

